import { Action, createReducer, on } from "@ngrx/store";
import * as fromCourseMetricsActions from "../actions/course-metrics.action";
import { CourseMetrics } from "cli-types";

// creating an interface to say what type the initialState will be
// using entities (data objects) instead of arrays is better for performance
export interface CourseMetricsState {
    courseMetrics: CourseMetrics | null;
    loaded: boolean;
    loading: boolean;
}

// set initial state as type CourseMetricsState
export const initialState: CourseMetricsState = {
    courseMetrics: null,
    loaded: false,
    loading: false,
};

const courseMetricsReducer = createReducer(
    initialState,
    on(fromCourseMetricsActions.loadCourseMetrics, (state) => {
        return {
            ...state,
            loading: true,
        };
    }),
    on(
        fromCourseMetricsActions.loadCourseMetricsSuccess,
        (state, { payload }) => {
            return {
                ...state,
                courseMetrics: payload,
                loading: false,
                loaded: true,
            };
        }
    ),
    on(fromCourseMetricsActions.loadCourseMetricsFail, (state) => {
        return {
            ...state,
            loading: false,
            loaded: false,
        };
    }),
    on(fromCourseMetricsActions.clearCourseMetricsStore, (state) => {
        return {
            ...state,
            courseMetrics: null,
            loading: false,
            loaded: false,
        };
    })
);

export function reducer(state: CourseMetricsState | undefined, action: Action) {
    return courseMetricsReducer(state, action);
}

// this is where we want to export some levels of state
export const getCourseMetrics = (state: CourseMetricsState) =>
    state.courseMetrics;
export const getCourseMetricsLoading = (state: CourseMetricsState) =>
    state.loading;
export const getCourseMetricsLoaded = (state: CourseMetricsState) =>
    state.loaded;
